"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _createSvgIcon = _interopRequireDefault(require("./utils/createSvgIcon"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/* eslint-disable */
var _default = (0, _createSvgIcon["default"])( /*#__PURE__*/_react["default"].createElement("g", null, /*#__PURE__*/_react["default"].createElement("path", {
  fillRule: "evenodd",
  d: "M6.5339 8c-.2282 0-.3643.2543-.2378.4442l5.4662 8.1992c.1131.1696.3623.1696.4754 0l5.4662-8.1992C17.8304 8.2543 17.6943 8 17.4661 8H6.5339z",
  clipRule: "evenodd"
})), 'ArrowDownSolidIcon');
/* eslint-enable */


exports["default"] = _default;